import {
  type RefObject,
  useLayoutEffect, useMemo, useRef, useState,
} from 'react';

export function useHeightTransition(): [RefObject<HTMLElement | null>, number | undefined] {
  const [contentHeight, setContentHeight] = useState<number>();
  const wrapperElementRef = useRef<HTMLElement | null>(null);
  const contentHeightRef = useRef(contentHeight);

  const resizeObserver = useMemo(() =>
    new ResizeObserver(() => {
      if (wrapperElementRef.current && contentHeightRef.current !== wrapperElementRef.current.offsetHeight) {
        contentHeightRef.current = wrapperElementRef.current.offsetHeight;
        setContentHeight(wrapperElementRef.current.offsetHeight);
      }
    }), []);

  useLayoutEffect(() => {
    if (wrapperElementRef.current) {
      setContentHeight(wrapperElementRef.current.offsetHeight);
      resizeObserver.observe(wrapperElementRef.current, {});
    }

    return () => resizeObserver.disconnect();
  }, [resizeObserver]);

  return [wrapperElementRef, contentHeight];
}
